import React, { ReactNode, useState } from 'react'

import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router'

import {
  Input,
  SectionSubtitle,
  ErrorModal,
  Button,
  BackButton,
} from '../../components'
import { Spacer } from '../../components/global'
import { useUser } from '../../context'

import { RecoverPassForm, FormularioRectangulo, TitleForm } from './styles'

const RecoverPassword = () => {
  const navigate = useNavigate()
  const { sendPasswordReset } = useUser()
  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | ReactNode | null>(null)
  const [confirmationModal, setConfimationModal] = useState(false)

  const handleRecoverPassword = async () => {
    setLoading(true)

    try {
      await sendPasswordReset(email)
      setMessage(
        <>
          <p>
            Correo de recuperación enviado a{' '}
            <span style={{ color: '#18B5DF' }}>{email}</span>
          </p>
          <p>Por favor revisa tu bandeja de entrada y spam.</p>
        </>,
      )
    } catch (error) {
      setMessage(
        <>
          <p>Ha ocurrido un error. Por favor intenta nuevamente. </p>
          <p>Si el problema persiste, contacta a la administración.</p>
        </>,
      )
      // setMessage(error)
    } finally {
      setLoading(false)
      setConfimationModal(true)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (emailPattern.test(value)) {
      setValidEmail(true)
      setEmail(value)
    } else {
      setValidEmail(false)
    }
  }

  return (
    <>
      {confirmationModal && message && (
        <ErrorModal
          errorMessage={message}
          setOpenModal={setConfimationModal}
          setError={setMessage}
        />
      )}

      <RecoverPassForm>
        <div className="holaSvg" />
        <TitleForm>Hola!</TitleForm>
        <FormularioRectangulo>
          {!loading ? (
            <>
              <BackButton
                goBack={() => navigate(-1)}
                withText={false}
                alignment="normal"
              />
              <SectionSubtitle
                fontSize={18}
                fontWeight={400}
                children="Recuperar contraseña"
              />

              <Spacer height={20} />
              <div className="containerInputPassword">
                <SectionSubtitle fontSize={12} fontWeight={500}>
                  Introduce el mail con el que te has dado de alta
                </SectionSubtitle>
                <Spacer height={10} />
                <Input
                  id="userLogin"
                  name="user"
                  placeholder="correo@correo.com"
                  onChange={handleChange}
                />
              </div>
              {!validEmail && email && (
                <p className="messageError">El email no es valido.</p>
              )}

              <Spacer height={20} />
              <Button
                className="dark-grey"
                onClick={handleRecoverPassword}
                label="Recuperar contraseña"
                width="180px"
                disabled={!validEmail || email.length === 0}
              />
            </>
          ) : (
            <Spinner />
          )}
        </FormularioRectangulo>
      </RecoverPassForm>
    </>
  )
}

export default RecoverPassword
